const extractPrefixSuffix = (indexValue) => {
    // const match = indexValue.match(/^(.*?)(\d+)(?!.*\d)/);
    // if (match) {
    //     return {
    //         prefix: match[1],
    //         suffix: match[2]
    //     };
    // }
    // return {
    //     prefix: indexValue,
    //     suffix: ''
    // };
    let left = 0;
    let right = indexValue?.length - 1;

    // Move right pointer leftward to find the start of the numeric part
    while (right >= left && indexValue?.charCodeAt(right) >= 48 && indexValue?.charCodeAt(right) <= 57) {
        right--;
    }

    return {
        prefix: indexValue?.toString()?.slice(0, right + 1),  // Prefix before the numeric part
        suffix: indexValue?.toString()?.slice(right + 1)      // Numeric suffix
    };
}

// Compare two index values using custom logic
const compareIndexValue = (aVal, bVal) => {
    let { prefix: prefixA, suffix: suffixA } = extractPrefixSuffix(aVal);
    let { prefix: prefixB, suffix: suffixB } = extractPrefixSuffix(bVal);

    if (prefixA < prefixB) return -1;
    if (prefixA > prefixB) return 1;

    let numA = suffixA ? parseInt(suffixA, 10) : 0;
    let numB = suffixB ? parseInt(suffixB, 10) : 0;

    return numA - numB;
}

// Custom sort function for index values
export const customSortByIndex = (data, index, order = 'asc') => {
    if (!index) {
        return data;
    }
    return data.sort((a, b) => {
        let aVal = typeof a === 'string' ? a : a[index];
        let bVal = typeof b === 'string' ? b : b[index];

        const result = compareIndexValue(aVal, bVal);
        return order === 'asc' ? result : -result;
    });
};

// Function to apply range filter using custom comparison
export const filterByRange = (data, index, from, to) => {
    if (!index) {
        return data;
    }
    return data.filter(val => {
        return (
            compareIndexValue(val[index], from) >= 0 &&
            compareIndexValue(val[index], to) <= 0
        );
    });
};
